export default "__VITE_ASSET__3580e69d__"